import { AxiosResponse } from "axios";
import { groupsApi, rolesApi } from "api";

export type UserAssociationResource = "groups" | "roles";

const resourceApi = {
  groups: groupsApi,
  roles: rolesApi,
};

interface UpdateResourceUserAssociationParams {
  resource: UserAssociationResource;
  resourceId: number;
  userId: number;
  associated: boolean;
}

export const getResourceUsers = (
  resource: UserAssociationResource,
  resourceId: number
): Promise<AxiosResponse> => resourceApi[resource].get(`/${resourceId}/users`);

export const updateResourceUserAssociation = ({
  resource,
  resourceId,
  userId,
  associated,
}: UpdateResourceUserAssociationParams): Promise<AxiosResponse> => {
  const path = `${resourceId}/users/${userId}`;
  return associated
    ? resourceApi[resource].post(path)
    : resourceApi[resource].delete(path);
};
